import { createContext } from "react";

const WarehouseContext = createContext();

export default WarehouseContext;
